import { MapPin, Phone } from "lucide-react";
import { useContent } from "../hooks/useContent";

const ContactSection = () => {
	const { data: content, isLoading } = useContent();
	const contact = content?.contact;
	return (
		<section id="contact" className="py-24 px-4 bg-maroon-gradient">
			<div className="max-w-6xl mx-auto">
				<div className="text-center mb-12">
					<p className="text-gold-light font-heading text-lg tracking-widest uppercase mb-2">Find Us</p>
					<h2 className="text-4xl md:text-5xl font-display font-bold text-gold-gradient mb-4">
						Contact Us
					</h2>
					<div className="w-24 h-1 bg-accent mx-auto rounded-full" />
				</div>

				<div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
					<div className="space-y-8">
						<div className="flex items-start gap-4">
							<div className="w-12 h-12 rounded-full bg-accent/20 flex items-center justify-center shrink-0">
								<MapPin className="w-6 h-6 text-gold" />
							</div>
							<div>
								<h3 className="text-cream font-display text-xl font-semibold mb-1">Location</h3>
								<p className="text-cream/70 font-body">{contact?.location}</p>
							</div>
						</div>
						<div className="flex items-start gap-4">
							<div className="w-12 h-12 rounded-full bg-accent/20 flex items-center justify-center shrink-0">
								<Phone className="w-6 h-6 text-gold" />
							</div>
							<div>
								<h3 className="text-cream font-display text-xl font-semibold mb-1">Phone</h3>
								<a href={`tel:${contact?.phone}`} className="text-cream/70 font-body hover:text-gold transition-colors">
									{contact?.phone}
								</a>
							</div>
						</div>
					</div>

					<div className="rounded-xl overflow-hidden border-2 border-gold/30 shadow-gold h-64 md:h-80">
						{
							contact?.mapEmbedUrl && (
								<iframe
									src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14284.82089438695!2d92.73!3d26.73!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3744b!2sBalipara!5e0!3m2!1sen!2sin!4v1"
									width="100%"
									height="100%"
									style={{ border: 0 }}
									allowFullScreen
									loading="lazy"
									referrerPolicy="no-referrer-when-downgrade"
									title="Swar Nrityam Location"
								/>
							)
						}
					</div>
				</div>
			</div>
		</section>
	);
};

export default ContactSection;
